export const TRANSITION_DURATION = 350;
